import React from 'react';
import { View, TextInput, StyleSheet, ViewStyle, Platform } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChangeText: (text: string) => void;
  style?: ViewStyle;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "Search",
  value,
  onChangeText,
  style,
}) => {
  return (
    <View style={[styles.container, Platform.OS === 'web' && styles.containerWeb, style]}>
      <SVG_COMPONENTS.MAGNIFYING_GLASS
        width={16}
        height={16}
        color={ADMIN_COLORS.TEXT_TERTIARY}
        style={styles.icon}
      />
      <TextInput
        style={styles.input}
        placeholder={placeholder}
        value={value}
        onChangeText={onChangeText}
        placeholderTextColor={ADMIN_COLORS.TEXT_TERTIARY}
        autoCapitalize="none"
        autoCorrect={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    paddingHorizontal: 12,
    height: 40,
  },
  containerWeb: {
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  icon: {
    marginRight: 8,
  },
  input: {
    flex: 1,
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_PRIMARY,
    paddingVertical: 0, // Remove default padding on Android
  },
});
